<template>
    <LearningCoachBanner :trainers="trainers">
        <template #title>
            <span v-html="$t('LearningCoachCloudSkillsBanner.title')"></span>
        </template>
        <template #description>
            <span v-html="$t('LearningCoachCloudSkillsBanner.description')"></span>
        </template>
        <template #buttons>
            <TotemButton
                color="secondary"
                class="learning-coach-banner__button"
                @click="openUrl('https://app.eduhouse.fi/palvelu/fi-cloudskills/koulutukset/etakoulutukset/63105215-avoin-cloudskills-viikkovalmennus')"
                :label="$t('LearningCoachCloudSkillsBanner.buttonAnu')"
            />
        </template>
    </LearningCoachBanner>
</template>

<script>
    import importAllImages from 'components/shared/mixins/importAllImages'
    import LearningCoachBanner from './LearningCoachBanner'
    export default {
        name: 'cloud-skills-learning-coach-banner',
        components: {
            LearningCoachBanner
        },
        mixins: [importAllImages],
        data () {
            return {
                trainers: {
                    images: [],
                    folder: 'cloudskillsbanner'
                }
            }
        },
        created () {
            this.trainers.images = this.importAll(require.context('@/assets/images/banners/cloudskillsbanner', false, /\.(png|jpe?g|svg)$/))
        },
        methods: {
            openUrl (url) {
                window.open(url, '_self')
            }
        }
    }
</script>

<style>
    .learning-coach-banner img {
        margin-right: -16px !important;
    }
</style>
